// removed by extract-text-webpack-plugin
module.exports = {"textarea":"_2Fj_eBb3f JmRuDZRyu y4wLu1mD3 vUrsJl1Yt _19QZFK_l1 _1NlI_spEh _1EdaqRqa1 _2OFXNnC9U"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/setupform-form/field/text-area/text-area.css
 ** module id = 2166
 ** module chunks = 0
 **/